import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import getTemplateById from '../../../utils/getTemplateById';
import {CreativeTemplatesManagerAgentToolName} from '../creativeTemplatesManagetAgent.enums';

const inputSchema = z.object({
  templateId: z.number(),
  includeName: z.boolean().nullable().optional(),
  includeDescription: z.boolean().nullable().optional(),
  includeCreativeId: z.boolean().nullable().optional(),
  includeFeatures: z.boolean().nullable().optional(),
  includeFormats: z.boolean().nullable().optional(),
  includeType: z.boolean().nullable().optional(),
  includeCreateTime: z.boolean().nullable().optional(),
  includeCreatedByUserName: z.boolean().nullable().optional(),
  includeUpdateTime: z.boolean().nullable().optional(),
  includeSource: z.boolean().nullable().optional(),
});

function getCreativeTemplateInfoTool(store: CLStore) {
  async function execute({
    input: {
      templateId,
      includeName = false,
      includeDescription = false,
      includeCreativeId = false,
      includeFeatures = false,
      includeFormats = false,
      includeType = false,
      includeCreateTime = false,
      includeCreatedByUserName = false,
      includeUpdateTime = false,
      includeSource = false,
    },
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const template = await getTemplateById(templateId, store);

    if (!template) {
      return toolError(`Template with ID ${templateId} not found.`);
    }

    const {
      id,
      name,
      description,
      creativeIds,
      features,
      formats,
      type,
      createTime,
      createdByUserName,
      updateTime,
      source,
    } = template;

    const templateMetadata = {
      id,
      ...(includeName && {name}),
      ...(includeDescription && {description}),
      ...(includeCreativeId && {creativeIds}),
      ...(includeFeatures && {features}),
      ...(includeFormats && {
        formats: formats.map((format) => ({format: format.format.formatString})),
      }),
      ...(includeType && {type}),
      ...(includeCreateTime && {createTime}),
      ...(includeCreatedByUserName && {createdByUserName}),
      ...(includeUpdateTime && {updateTime}),
      ...(includeSource && {source}),
    };

    return toolResult(JSON.stringify(templateMetadata));
  }

  return tool({
    name: CreativeTemplatesManagerAgentToolName.GetCreativeTemplateInfo,
    description: 'Get info related to specific creative template',
    displayName: 'Getting templates metadata',
    execute,
    inputSchema,
  });
}

export default getCreativeTemplateInfoTool;
